module.exports = __webpack_public_path__ + "static/media/cmr_9.8469f80f.jpg";